import { useQuery } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { retryUnlessProviderError } from '../../utils/queryRetry.js';
import { issuesKeys } from '../queryKeys.js';

/**
 * A site's issues. Shares Monitor's cache key, so both surfaces refresh
 * together and one fetch serves both within the stale window.
 */
export function useProjectIssues(siteId: string | null) {
  const { fetchSiteIssues } = useClientApis().issues;
  return useQuery({
    queryKey: issuesKeys.list(siteId),
    queryFn: ({ signal }) => fetchSiteIssues(siteId!, signal),
    enabled: !!siteId,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    retry: retryUnlessProviderError,
  });
}
